import {ProductPropertiesPane} from '../components/NodePropertiesPane.jsx'
import DpContentType from '../_DESIGN/PropertiesControllerDpContentType.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import Pm from '../PM/PropertiesControllerPm.jsx'
import Model from './ModelRulemrm.mjs'
import RmType from './RmType.jsx'

export default function PropertiesPaneRulemrm(props) {
    return (
        <ProductPropertiesPane
            controllers={
                <>
                    <DpContentType />
                    <Text prop="rmNo" />
                    <Text prop="rmName" />

                    <Select
                        options={RmType}
                        prop="rmType"
                    />

                    <Pm />
                </>
            }

            Model={Model}
            {...props}
        />
    )
}
